module.exports = {"542525100":"革吉镇","542525200":"雄巴乡","542525201":"亚热乡","542525202":"盐湖乡","542525203":"文布当桑乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542525.json
// module id = 2773
// module chunks = 0